export default __webpack_public_path__ + "66d03a7200aabe449731c340f4bf5cbd.jpg";